/**
 * Created by Arif Topcu in 2019
 */

import React, { memo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import ComplicationSelector from "@ls/grouping-complication-selector";
import SelectionState from "state/selections/SelectionState";
import TrackingErrorSelectorComplication from "./TrackingErrorSelectorComplication";
import TrackingErrorDefinition from "state/te/TrackingErrorDefinition";
import { selectDefinitions } from "state/te/selectors";
import { setDefinition as setTeDefinition } from "state/te/actions";

const TrackingErrorSelector = () => {
  const dispatch = useDispatch();
  const definitions = useSelector(
    selectDefinitions(SelectionState.UNCOMMITTED)
  );
  const setDefinition = useCallback(
    (definitions, idx) => dispatch(setTeDefinition(definitions, idx)),
    [dispatch]
  );

  return (
    <ComplicationSelector
      selectedDefinitions={definitions}
      setDefinition={setDefinition}
      getDefaultDefinition={TrackingErrorDefinition.getDefault}
      ComplicationComponent={TrackingErrorSelectorComplication}
      btnTitle={"Tracking Error"}
      addMoreText={"Tracking Error Column"}
    />
  );
};

export default memo(TrackingErrorSelector);
